<template>
    <div>
        <div class="handle-mod">
            <template v-if="info.seal_status * 1 > 0">
                <div class="button report disabled"><i class="icon i_tips"></i>举报</div>
            </template>
            <template v-else>
                <div class="button report" @click="showTipsClick"><i class="icon i_tips"></i>举报</div>
            </template>
            <div :class="{'button':true,'like':true,'active':info.like == 1}">
                <i :class="{icon: true,i_zang: info.like != 1,i_zang_ed: info.like == 1}"></i>{{text2}} {{info.support || "0"}}
            </div>
            <Collect :info="info"></Collect>
            </div>
            <div :class="{'modal':1,'modal_wrapper':1,'none': !showTips}">
                <div class="content tipsinfolist">
                    <h3>举报内容</h3>
                    <div class="label">请选择原因(可多选)</div>
                    <div class="tipwrap">
                        <ul id="tipslist">
                            <li>广告 <i class="icon i_ckbox"></i></li>
                            <li>重复、旧闻 <i class="icon i_ckbox"></i></li>
                            <li>低俗 <i class="icon i_ckbox"></i></li>
                            <li>与事实不符 <i class="icon i_ckbox"></i></li>
                            <li>内容质量差 <i class="icon i_ckbox"></i></li>
                            <li>抄袭 <i class="icon i_ckbox" ></i></li>
                        </ul>
                        <div class="btn_wrapper">
                            <span class="btn" @click="closeTipsClick">取消</span>
                            <span class="btn save">举报</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
import { isexinfo } from "../../utils/base"
import Collect from "../../components/programme/Collect.vue"
export default {
    name: "Like",
    props: ["info"],
    components: {
        Collect
    },
    data () {
        return {
            text1: "没用",
            text2: "赞",
            showTips: 0
        }
    },
    mounted () {
        this.inint()
    },
    methods: {
        selectTip (e) {
            var li = e.target;
            // eslint-disable-next-line eqeqeq
            if (e.target.tagName != "LI") {
                li = e.target.parentElement;
            }
            this.setSelectTip(li);
        },
        // setSelectTip (li, nochk) {
        //     if (nochk) {
        //         li.class = "";
        //     } else {
        //         toggleClass(li, "selected");
        //     }
        //     var icon = li.querySelectorAll("i")[0];
        //     if (li.class.indexOf("selected") > -1) {
        //         icon.class = "icon i_ckboxed";
        //     } else {
        //         icon.class = "icon i_ckbox";
        //     }
        // },
        closeTipsClick () {
            this.showTips = 0
            // var tipslist = document.getElementById("tipslist");
            // var lis = tipslist.querySelectorAll("li");
            // for (var i = 0; i < lis.length; i++) {
            //     this.setSelectTip(lis[i], 1);
            // }
        },
        showTipsClick () {
            if (this.info.ispreinfo) {
                return;
            }
            this.showTips = 1
        },
        inint () {
            if (isexinfo(this.info.type)) {
                this.text1 = "不喜欢"
                this.text2 = "喜欢"
            }
        }
    }
}
</script>
